import type { LangStrings } from './en';

export const ru: LangStrings = {
  back: 'НАЗАД',
  next: 'ДАЛЕЕ',
  retry: 'ЗАНОВО',
  replay: 'ПОВТОР',
  sector: 'СЕКТОР',
  sectors: 'СЕКТОРЫ',
  levels: 'УРОВНИ',
  cleared: 'ПРОЙДЕНО',
  open: 'ОТКРЫТ',
  locked: 'ЗАКРЫТ',
  tba: 'TBA',
  slot_reserved: 'РЕЗЕРВ',
  sfx_on: 'ЗВУК ВКЛ',
  sfx_off: 'ЗВУК ВЫКЛ',
  reset_progress: 'СБРОС ПРОГРЕССА',
  wiped_reloading: 'СБРОС, ПЕРЕЗАГРУЗКА…',
  got_it: '› ПОНЯЛ ‹',

  boot_eyebrow: 'ПРОТОКОЛ КАСКАД  //  BUILD',
  boot_tagline: 'ОДИН ТАП. ОДИН КАСКАД. БЕЗ ОТКАТА.',
  boot_subtitle: '信号崩壊  ·  ЛОГИКА КАСКАДА',
  boot_cta: '› ТАП ДЛЯ СТАРТА ‹',
  boot_region: 'РЕГИОН ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // ОНЛАЙН',

  menu_header_subtitle: 'NØDUS / ВЫБОР.СЕКТОРА',
  menu_engine_label: 'движок коллапса сигнала',
  menu_signals_down: 'сигналов сбито',
  menu_tap_chapter: 'НАЖМИ ГЛАВУ ЧТОБЫ ВОЙТИ',
  menu_language_label: 'ЯЗЫК',

  chapter_signals_down: 'сигналов сбито',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: 'КОДА',
  chapter_coda_tagline: 'Ничего нового. Всё вместе.',

  hud_tap_to_breach: '▾  тапни узел чтобы пробить  ▾',
  hud_tap_to_skip: "пропустить  ▸▸",
  hud_drag_zoom_help: 'тяни для перемещения · колесо/щипок для зума',
  hud_required: 'ОБЯЗАТ',
  hud_core_online: 'ЯДРО АКТИВНО',
  hud_core_down: 'ЯДРО СБИТО',

  tut_tap_any_node: 'НАЖМИ ЛЮБОЙ УЗЕЛ',
  tut_they_all_work: 'тут все работают',

  brief_eyebrow: '◂ БРИФИНГ ▸',
  brief_title: 'ОДИН ТАП.\nОДИН КАСКАД.',
  brief_line_1: '› У тебя ровно ОДИН тап.',
  brief_line_2: '› Он запускает цепную реакцию в сети.',
  brief_line_3: '› Уничтожь каждый ОБЯЗАТ (циан-ромб) чтобы победить.',
  brief_line_4: '› Никогда не дай импульсу коснуться ЗАЩИЩЁННОГО (красный).',
  brief_begin: '› НАЧАТЬ БРИФИНГ ‹',

  result_win_headline: 'СИСТЕМА РУХНУЛА',
  result_fail_headline: 'КАСКАД ПРОВАЛЕН',
  result_first_clear: '› ПЕРВАЯ ПОБЕДА ‹',
  result_try_label: '› СОВЕТ',
  result_cleared_suffix: 'ПРОЙДЕНО',
  result_aborted_suffix: 'ЗАПУСК ПРЕРВАН',
  result_win_body_template: '{ticks} тиков. {nodes} узлов сбито.',

  fail_protected_overload: 'Перегрузка защищённого узла. Каскад задел то, чего не должен.',
  fail_forbidden_trigger: 'Запретная линия пронесла сигнал. Сработала жёсткая тревога.',
  fail_required_not_reached: 'Обязательный узел не получил импульс. Цепь до него не дотянулась.',
  fail_required_under_threshold: 'Обязательный узел не получил достаточно импульсов. Первый затух раньше второго.',
  fail_core_not_collapsed: 'Ядро выжило. Каскад рассеялся раньше, чем дошёл.',
  fail_core_under_threshold: 'Ядро получило импульсы, но мало, они не сошлись вовремя.',
  fail_core_shielded: 'Импульсы ядра заблокированы. Щит ещё работал.',
  fail_chain_died: 'Цепь умерла, не дойдя ни до чего.',
  fix_protected_overload: 'Выбери стартер, чей каскад никогда не доходит до красной опасности. Сначала проследи выходы.',
  fix_forbidden_trigger: 'Избегай стартеров, стреляющих В красный пунктир. Тревога срабатывает сразу.',
  fix_required_not_reached: 'Твой стартер не связан с этим узлом. Смотри стрелки, направленные провода идут только в одну сторону.',
  fix_required_under_threshold: 'Найди маршрут, доставляющий два импульса этому узлу, сплиттер или два сходящихся пути обычно подходят.',
  fix_core_not_collapsed: 'Нужно больше схождения в ядро. Сплиттеры, конденсаторы и реле существуют чтобы его кормить.',
  fix_core_under_threshold: 'Импульсы приходят слишком медленно. Используй сплиттеры или приводи все импульсы в один тик.',
  fix_core_shielded: 'Сбей все щиты до решающего выстрела. Запоздалый провод задержки работает чисто.',
  fix_chain_died: 'Твой стартер связан только с одним узлом. Возьми что-то в центре сети.',

  popup_new_node: '◂ НОВЫЙ ТИП УЗЛА ▸',
  popup_new_wire: '◂ НОВЫЙ ТИП ПРОВОДА ▸',

  node_normal_title: 'УЗЕЛ',
  node_normal_tagline: 'Базовая единица. Тапни для запуска каскада.',
  node_normal_b1: 'Рушится от первого пришедшего импульса.',
  node_normal_b2: 'Стреляет импульсом по каждому открытому исходящему проводу.',
  node_normal_b3: 'Без порога, один удар и его нет.',

  node_required_title: 'ОБЯЗАТЕЛЬНЫЙ',
  node_required_tagline: 'Нужно сбить каждый ОБЯЗАТЕЛЬНЫЙ чтобы победить.',
  node_required_b1: 'Циан-ромб. Слабо пульсирует в покое чтобы его заметить.',
  node_required_b2: 'Некоторые требуют 2+ импульсов в одном окне.',
  node_required_b3: 'Промахни хотя бы один, запуск провален.',
  node_required_note: 'Маленький круг точек вокруг узла показывает его заряд.',

  node_protected_title: 'ЗАЩИЩЁННЫЙ',
  node_protected_tagline: 'Коснёшься, весь запуск умрёт.',
  node_protected_b1: 'Красный аварийный крест. Помечен угловыми скобками.',
  node_protected_b2: 'Любой импульс на нём = мгновенный ПРОВАЛ.',
  node_protected_b3: 'Спланируй маршрут, который его никогда не питает.',

  node_relay_title: 'РЕЛЕ',
  node_relay_tagline: 'При падении открывает запертые провода.',
  node_relay_b1: 'Золотой шеврон. Его цели, ЗАПЕРТЫЕ пунктирные провода.',
  node_relay_b2: 'Когда реле падает, его запертые провода вспыхивают.',
  node_relay_b3: 'Удобно для открытия пути к охраняемому узлу.',

  node_shield_title: 'ЩИТ',
  node_shield_tagline: 'Телохранитель. Принимает удары за другой узел.',
  node_shield_b1: 'Зелёное шестиугольное кольцо вокруг защищаемого узла.',
  node_shield_b2: 'Прямой импульс на защищённый узел НИЧЕГО не делает.',
  node_shield_b3: 'Сначала сбей щит, затем нанеси добивающий удар.',
  node_shield_note: 'Провода ЗАДЕРЖКИ (золотой пунктир) идеальны для удара после щита.',

  node_splitter_title: 'СПЛИТТЕР',
  node_splitter_tagline: 'Умножает импульсы на всех выходах.',
  node_splitter_b1: 'Пурпурная вилка. 1 импульс на входе → N импульсов на каждый выход.',
  node_splitter_b2: 'Метка X показывает коэффициент деления.',
  node_splitter_b3: 'Поставляет множественные удары, которые нужны ЯДРУ с высоким порогом.',

  node_capacitor_title: 'КОНДЕНСАТОР',
  node_capacitor_tagline: 'Хранит импульс и пере-излучает, буфер.',
  node_capacitor_b1: 'Жёлтый символ конденсатора. Передаёт импульс через 3 тика.',
  node_capacitor_b2: 'Воспринимай как встроенную ЗАДЕРЖКУ в маршруте.',
  node_capacitor_b3: 'Позволяет более позднему импульсу прибыть ПОСЛЕ падения щита.',

  node_core_title: 'ЯДРО',
  node_core_tagline: 'Цель. Высокий порог, быстрое затухание.',
  node_core_b1: 'Фиолетовый реактор. Нужно много сходящихся импульсов чтобы упасть.',
  node_core_b2: 'Заряд ЗАТУХАЕТ, импульсы должны приходить плотно.',
  node_core_b3: 'Часто прикрыто щитами. Сбей их, затем затопи ядро.',
  node_core_note: 'Уровень с ЯДРОМ выигрывается его обрушением. Обязательные (если есть) тоже учитываются.',

  wire_directional_title: 'НАПРАВЛЕННЫЙ ПРОВОД',
  wire_directional_tagline: 'Односторонний проводник. Циан со стрелкой.',
  wire_directional_b1: 'Импульс идёт только в направлении стрелки.',
  wire_directional_b2: 'Тапни не с той стороны стрелки, ничего не пойдёт.',
  wire_directional_b3: 'Прослеживай стрелки от стартера до самого низа.',

  wire_delay_title: 'ПРОВОД ЗАДЕРЖКИ',
  wire_delay_tagline: 'Золотой пунктир. Импульс приходит на 3 тика позже.',
  wire_delay_b1: 'Удобен для тайминга, приземли импульс ПОСЛЕ падения щита.',
  wire_delay_b2: 'Или сложи два импульса на узле с высоким порогом.',
  wire_delay_b3: 'Промахни тайминг, первый импульс затухнет раньше.',

  wire_locked_title: 'ЗАПЕРТЫЙ ПРОВОД',
  wire_locked_tagline: 'Серый пунктир + замок. Закрыт пока что-то не откроет.',
  wire_locked_b1: 'Каждым запертым проводом управляет РЕЛЕ.',
  wire_locked_b2: 'Когда реле рушится, его запертые провода открываются.',
  wire_locked_b3: 'Не трать тап на попытку напрямую запитать запертый провод.',

  wire_forbidden_title: 'ЗАПРЕТНЫЙ ПРОВОД',
  wire_forbidden_tagline: 'КРАСНЫЙ пунктир с крестом. Коснёшься = мгновенный провал.',
  wire_forbidden_b1: 'Любой импульс, даже транзитный, поднимает тревогу.',
  wire_forbidden_b2: 'Следи за ними на выходах каждого стартера.',
  wire_forbidden_b3: 'Выбери стартер, чей маршрут НИКОГДА не задевает красный.',

  wire_burn_title: 'ГОРЯЩИЙ ПРОВОД',
  wire_burn_tagline: 'Латунно-оранжевый. Одноразовый проводник, сгорает после импульса.',
  wire_burn_b1: 'Пропускает ровно ОДИН импульс, затем умирает навсегда.',
  wire_burn_b2: 'Планируй его единственное использование тщательно, второго шанса нет.',
  wire_burn_b3: 'Сгорел, ни один каскад через него не пройдёт.',

  callout_required_crashed: 'ОБЯЗАТ СБИТ',
  callout_core_breached: 'ЯДРО ПРОБИТО',
  callout_shield_dropped: 'ЩИТ ПАЛ',
  callout_relay_opened: 'РЕЛЕ ОТКРЫТО',
  callout_protected_hit: 'ЗАЩИЩЁННЫЙ ПОРАЖЁН',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: 'Ваше касание',
  result_map_broke: 'Сбой здесь',
  result_map_answer: 'Решение',
  result_show_answer: 'Показать ответ',
  menu_endless_line: 'Генерируемые уровни, три жизни. Чем глубже, тем жёстче.',
  menu_best: 'Рекорд LV {n}',
  menu_best_streak: 'Рекорд LV {n}  ·  серия ×{s}',
  menu_resume: 'Продолжить LV {n}',
  menu_start: 'Начать LV 1',
  result_run_total: 'Итог забега {n}',
  result_streak: 'Серия ×{n}',
  result_streak_wins: '{n} побед подряд',
  legend_title: 'Легенда',
  legend_nodes: 'УЗЛЫ',
  legend_wires: 'ПРОВОДА',
  legend_close: 'Нажмите в любом месте, чтобы закрыть',
  settings_sync_now: 'Синхронизировать ({who})',
  settings_sign_in: 'Войдите для синхронизации',
  settings_sign_out: 'Выйти',

};
